import { ICategoriesNodes, ICategory } from "../lib/types";

export const parseCategories = {
  getSlug: (categories: ICategoriesNodes) => {
    if (categories && categories.nodes && categories.nodes.length > 0) {
      return categories.nodes[0].slug;
    }

    return '';
  },

  getCleanURI: (category: ICategory) => {
    return category.uri.replace('/media', '');
  },
};
